// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"60ba1132","111":"dcd2a66a","706":"122ca833","787":"275152e6","803":"8e727343","825":"06e0c17a","966":"b770edc3"}[chunkId] + ".chunk.js";
};